// src/styles/themes.js
export const lightTheme = {
    background: '#f7f7f7',
    text: '#0a192f',
    accent: '#64ffda',
    secondary: '#8892b0',
  };
  
  export const darkTheme = {
    background: '#0a192f',
    text: '#ccd6f6',
    accent: '#64ffda',
    secondary: '#8892b0',
  };